import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { catchError, map, Observable, throwError } from 'rxjs';
import {
  UsersInterface,
  GrantLeavesData,
} from '../../routes/leave-management/grant-leaves/grant-leaves.interface';
import { SnackbarService } from '../snackbar.service';

@Injectable({
  providedIn: 'root',
})
export class GrantLeavesService {
  http = inject(HttpClient);
  baseUrll = environment.apiBaseUrl;
  alertService = inject(SnackbarService);

  constructor() {}

  getUsersList(): Observable<UsersInterface[]> {
    return this.http
      .get<{
        success: boolean;
        data: { users: { id: string; name: string }[] };
      }>(`${this.baseUrll}/users/me/relations`)
      .pipe(
        map((res) => {
          if (res.success) {
            return res.data.users;
          } else {
            throw new Error('Failed to fetch users list');
          }
        }),

        catchError((err) => {
          console.error('Error fetching users list:', err);
          this.alertService.showError('Error fetching users list');

          return throwError(() => err);
        }),
      );
  }

  grantLeaves(data: GrantLeavesData) {
    return this.http
      .post<{
        success: boolean;
        message?: string;
        messageCode?: string;
      }>(`${this.baseUrll}/activities/grant`, data)
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((err) => {
          console.error('Error granting leaves:', err);
          return throwError(() => err);
        }),
      );
  }

  getLeavesTypes(): Observable<string[]> {
    return this.http
      .get<{
        success: boolean;
        data: { types: string[] };
      }>(`${this.baseUrll}/leave-management-templates/grant-leave-types`)
      .pipe(
        map((res) => {
          if (res.success) {
            return res.data.types;
          } else {
            this.alertService.showError('Failed to fetch leave types');
            throw new Error('Failed to fetch leave types');
          }
        }),
      );
  }
}
